import { render, staticRenderFns } from "./adv-fullscreen.component.vue?vue&type=template&id=0d653a04&"
import script from "./adv-fullscreen.component.vue?vue&type=script&lang=ts&"
export * from "./adv-fullscreen.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports